export const TRIAL_UPGRADE_URL = "https://buy.stripe.com/3cIeVcfGAcLu1CFeTqgrS0e";

// Same rule as SignalTable: a non-subscribed, non-admin user with a trial end date.
export function isTrialUser(): boolean {
    return (
        localStorage.getItem("isSub") !== "true" &&
        localStorage.getItem("isAdmin") !== "true" &&
        !!localStorage.getItem("trialEndsAt")
    );
}

// Trial users see the first third of any list; the rest renders blurred behind a banner.
export function trialVisibleCount(total: number, isTrial: boolean): number {
    return isTrial ? Math.ceil(total / 3) : total;
}

export const TRIAL_LOCKED_CLASS = "blur-sm pointer-events-none select-none";
